import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowRightIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/links";
type FloatingCTAProps = {
  anchorId: string;
};
export function FloatingCTA({
  anchorId
}: FloatingCTAProps) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const check = () => {
      const anchor = document.getElementById(anchorId);
      if (!anchor) return;
      setVisible(anchor.getBoundingClientRect().bottom < 0);
    };
    check();
    window.addEventListener("scroll", check, {
      passive: true
    });
    window.addEventListener("resize", check);
    return () => {
      window.removeEventListener("scroll", check);
      window.removeEventListener("resize", check);
    };
  }, [anchorId]);
  return <AnimatePresence data-id="element-37" data-mp="38c0h9dd98ccl">
      {visible && <motion.div initial={{
      y: 24,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 24,
      opacity: 0
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 px-3 pb-3 pt-2 sm:pb-5" data-id="element-38" data-mp="38cs685ccjbtw">
          <a href={CHECKOUT_URL} className="animate-cta-shake mx-auto flex w-full max-w-md items-center justify-between gap-3 rounded-2xl bg-cta px-5 py-3.5 text-white shadow-[0_10px_30px_rgba(14,26,51,0.35)] ring-2 ring-white/80 hover:bg-ctadark focus-visible:outline focus-visible:outline-4 focus-visible:outline-goldlight" data-id="element-39" data-mp="335doxspz4ru7">
            <span className="flex flex-col text-left" data-id="element-40" data-mp="2kduljks1fbrn">
              <span className="text-[15px] font-extrabold uppercase leading-tight tracking-wide" data-id="element-41" data-mp="26djtwfiwlt5f">
                Get the Blueprint™
              </span>
              <span className="text-xs font-medium text-white/85" data-id="element-42" data-mp="2bcwq3qvo0cko">
                <s className="opacity-70" data-id="element-43" data-mp="4lnlhes18zev">$294</s> today only $27 USD
              </span>
            </span>
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-white text-cta" data-id="element-44" data-mp="9jyw3rq5jdy5">
              <ArrowRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-45" data-mp="77wo0uvv7rbr" />
            </span>
          </a>
        </motion.div>}
    </AnimatePresence>;
}